import React, { Fragment, useEffect, useState } from 'react';
import { utils } from '../../utils/Utils';
import $ from "jquery";
import ReactDom, { createPortal } from "react-dom";
import MultiLocationDropdown from "../../VagaroComponent/MultiLocationDropdown";
import isValidLocation from './IsValidLocation';

export default function RenderBusinessBookNow({ data, layout, root, allowMultiLoc, userContext, VgUrl }: { data: any, layout: string, root: string, allowMultiLoc: boolean, userContext: any, VgUrl: any }) {
    var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;
    const [Multiloction, setMultiloction] = useState(allowMultiLoc && !IsEditor);
    const [Url, setUrl] = useState("");

    if (!Multiloction) {
        $(".wbloader").css("display", "block");
    }

    useEffect(() => {
        if (data != undefined && data != null && data != "") {
            setUrl(data.vagaroURL);
        }

    }, [data]);

    useEffect(() => {
        if (Multiloction) {
            let BData = userContext.MultilocationData.filter(
                (col: any) => col.businessID > 0 && col.isServiceAvailable == true && isValidLocation(col)
            );
            let Multilocations: any[] = [];
            BData.map((data: any) => {
                Multilocations.push(data);
            });
            if (BData.length > 1) {
                ReactDom.render(
                    <MultiLocationDropdown
                        key="book-now-multilocation-portal"
                        Sitedata={Multilocations}
                        OnClickEvent={(VgUrl: any) => { setMultiloction(false); setUrl(VgUrl); }}
                        Mode={"wbBook"}
                        userContext={userContext}
                        ControlID={"wbmultilocationgroup"}
                        options={Multilocations}
                        searchInputPlaceholder={"Search Business"}
                        layoutID={1}
                        isShowHeader={true}
                    />,
                    document.getElementById("OpenDialogMultiLocation") as any
                )
            }
        }
    }, []);

    var glbbackground: any = $("#dvglbstyle").find("#glbbackground");
    glbbackground = glbbackground.css("background-color");

    switch (Multiloction) {
        case true:
            let Multilocations: any[] = [];
            let BData = userContext.MultilocationData.filter(
                (col: any) => col.businessID > 0 && col.isServiceAvailable == true && isValidLocation(col)
            );
            BData.map((data: any) => {
                Multilocations.push(data);
            });
            return <Fragment>
                {utils.isNotEmptyOrWhiteSpace(BData) && BData.length == 1 &&
                    <Fragment>
                        <div id={"dvglbstyle"} style={{ display: "none" }}>
                            <button id="btnprimarybutton" className="v-button primary invisible-button"></button>
                            <button id="btnprimarybuttonhover" className="v-button-hover primary"></button>
                            <button id="btnsecondary" className="v-button secondary"></button>
                            <button id="btnsecondarybuttonhover" className="v-button-hover secondary"></button>
                            <div id="txtfontfamily" className="v-text"></div>
                            <button id="btnrating" className="v-filled-star"></button>
                            <button id="glbbackground" className="v-site"></button>
                            <h2 id="glbHeadingFont"></h2>
                        </div>
                        <div id="divbooknowiframe" className='vgFrameWrapper' style={{ minHeight: "80vh" }}>
                            <iframe scrolling="no" id={"booknow" + root} style={{ backgroundColor: glbbackground, minHeight: "80vh" }} onLoad={() => { LoadBookNow(root) }} src={utils.SiteName() + BData[0].vagaroURL + "/book-now?Type=Builder&Event=WBBusinessServices"} width="100%"></iframe>
                            {IsEditor && <div style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }} onClick={(e) => e.preventDefault()}></div>}
                        </div>
                    </Fragment>
                }
            </Fragment>
        case false:
            return <Fragment>
                {(utils.isNotEmptyOrWhiteSpace(data) && utils.isNotEmptyOrWhiteSpace(Url)) &&
                    <Fragment>
                        <div id={"dvglbstyle"} style={{ display: "none" }}>
                            <button id="btnprimarybutton" className="v-button primary invisible-button"></button>
                            <button id="btnprimarybuttonhover" className="v-button-hover primary"></button>
                            <button id="btnsecondary" className="v-button secondary"></button>
                            <button id="btnsecondarybuttonhover" className="v-button-hover secondary"></button>
                            <div id="txtfontfamily" className="v-text"></div>
                            <button id="btnrating" className="v-filled-star"></button>
                            <button id="glbbackground" className="v-site"></button>
                            <h2 id="glbHeadingFont"></h2>
                        </div>
                        <div id="divbooknowiframe" className='vgFrameWrapper' style={{ minHeight: "80vh" }}>
                            <iframe scrolling="no" id={"booknow" + root} style={{ backgroundColor: glbbackground, minHeight: "80vh" }} onLoad={() => { LoadBookNow(root) }} src={utils.SiteName() + Url + "/book-now?Type=Builder&Event=WBBusinessServices"} width="100%"></iframe>
                            {IsEditor && <div style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }} onClick={(e) => e.preventDefault()}></div>}
                        </div>
                    </Fragment>
                }
            </Fragment>
    }

}

const sendPositionbook = function (glbIframeParentID: any, src: any) {
    if (glbIframeParentID != '' && typeof glbIframeParentID != 'undefined') {
        var parentid = $('#' + glbIframeParentID) as any;
        var currentScrollPositionofParent = (document.scrollingElement as any).scrollTop;
        var iframestartposition = parentid.find('iframe').offset().top;
        var modalTop = currentScrollPositionofParent - iframestartposition
        var modalHeight = window.screen.availHeight;
        if (modalTop < 0) {
            modalTop = 0;
        }

        parentid.find('iframe')[0].contentWindow.postMessage('{"eventType": "modalPosition", "modalTop" : ' + modalTop + ',"modalHeight" : "' + modalHeight + '"}', getSource(src));
    }
}
const LoadBookNow = function (root: string) {


    const getId = 'booknow' + root;

    if (document.getElementById(getId) !== undefined || document.getElementById('booknow') !== null) {
        var iframeElement = document.getElementById(getId) as any;
        if (iframeElement) {
            var styleobject: any = {};
            var gblstyle: any = $("#dvglbstyle");
            var primarybutton: any = gblstyle.find("#btnprimarybutton");
            var secondorybutton: any = gblstyle.find("#btnsecondary");
            var primarybuttonHover: any = gblstyle.find("#btnprimarybuttonhover");
            var secondorybuttonHover = gblstyle.find("#btnsecondarybuttonhover");
            var lblstyle: any = gblstyle.find("#txtfontfamily");
            var btnrating: any = gblstyle.find("#btnrating");
            var glbbackground: any = gblstyle.find("#glbbackground");
            var glbHeadFonts: any = gblstyle.find("#glbHeadingFont");
            styleobject.primarybuttoncolor = primarybutton.css("color");
            styleobject.primarybuttonbackgroundcolor = primarybutton.css("background-color");
            styleobject.primarybuttonHoverbackgroundcolor = primarybuttonHover.css("background-color");
            styleobject.primarybuttonborderradius = primarybutton.css("border-radius");
            styleobject.primarybuttonboxshadow = primarybutton.css("box-shadow");
            styleobject.primarybuttonbackgroundimage = primarybutton.css("background-image");

            styleobject.secondorybuttonbuttoncolor = secondorybutton.css("color");
            styleobject.secondorybuttonbuttonbackgroundcolor = secondorybutton.css("background-color");
            styleobject.secondorybuttonbuttonHoverbackgroundcolor = secondorybuttonHover.css("background-color");
            styleobject.secondorybuttonbuttonborderradius = secondorybutton.css("border-radius");
            styleobject.secondorybuttonbuttonboxshadow = secondorybutton.css("box-shadow");
            styleobject.secondorybuttonbuttonbackgroundimage = secondorybutton.css("background-image");
            
            styleobject.lblstylefontfamily = 'proxima-nova'
            styleobject.lblstylecolor = lblstyle.css("color");
            styleobject.lblstylefontweight = lblstyle.css("font-weight");
            styleobject.lblstylefontsize = lblstyle.css("font-size");
            styleobject.btnratingcolor = btnrating.css("color");
            styleobject.glbbackgroundcolor = glbbackground.css("background-color");
            styleobject.glbHeadingFonts = 'proxima-nova'
            var cookieobject: any = {};
            cookieobject.vdsid = localStorage.getItem("vdsid");
            var styledata: any = { 'eventType': 'addStyle', style: styleobject, 'parentID': 'divbooknowiframe', 'cookieobject': cookieobject }
            iframeElement.contentWindow.postMessage(JSON.stringify(styledata), getSource(iframeElement.src));
            sendPositionbook('divbooknowiframe', iframeElement.src);
        }
    }
}

function getSource(src: any) {
    var _target = null;
    if (_target == null) {
        var targetRegex = /^(https*:\/\/[^\/]*).*$/g;
        var match = targetRegex.exec(src);
        if (match) {
            _target = match[1];
        }
    }
    return _target;
}


